import { useEffect, useRef, useState } from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import scrollDownSvg from "../../assets/images/icons/scroll_down.svg";
import scrollDownMobileSvg from "../../assets/images/icons/scroll_down_mobile.svg";
import logoWhiteSvg from "../../assets/images/logo_white.svg";
import logoWhite from "../../assets/images/logo_white.png";
// import logoBlackSvg from "../../assets/images/logo_black.svg";
import logoBlack from "../../assets/images/logo_black.png";
import appStoreSvg from "../../assets/images/icons/app_store.svg";
import playStoreSvg from "../../assets/images/icons/play_store.svg";
import flowerStarSvg from "../../assets/images/flower_star.svg";
import familySvg from "../../assets/images/family.svg";
import researchSvg from "../../assets/images/research.svg";
import greenMonsterSvg from "../../assets/images/green_monster.svg";
import studyLifeSvg from "../../assets/images/study_life.svg";
import section1Svg from "../../assets/images/section1.svg";
import sectionTitle2Svg from "../../assets/images/section2_title.svg";
import sectionDescription2Svg from "../../assets/images/section2_description.svg";
import section3TitleSvg from "../../assets/images/section3_title.svg";
import sectionDescription3Svg from "../../assets/images/section3_description.svg";
import section4TitleSvg from "../../assets/images/section4_title.svg";
import sectionDescription4Svg from "../../assets/images/section4_description.svg";
import section5TitleSvg from "../../assets/images/section5_title.svg";
import sectionDescription5Svg from "../../assets/images/section5_description.svg";
import section6TitleSvg from "../../assets/images/section6_title.svg";
import sectionDescription6Svg from "../../assets/images/section6_description.svg";
import appDownloadSvg from "../../assets/images/app_download.svg";
import yellowMonsterLottie from "../../assets/images/lotties/Yellow_Monster.json";
import buttonHamburgerWhiteSvg from "../../assets/images/icons/button_hamburger_white.svg";

import serverMaintenance from "../../assets/images/server_maintenance.png";

import "../../assets/css/app_landing.scss";
import Lottie from "react-lottie-player";
import SvgPopup from "../../components/modal/svg_modal";

function AppLanding() {
  const fullpageApiRef = useRef(null);
  const [sectionIndex, setSectionIndex] = useState(0);
  const [visitedSections, setVisitedSections] = useState(new Set());
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onNextPage = () => {
    fullpageApiRef.current.moveSectionDown();
  };

  useEffect(() => {
    document.body.style.backgroundColor = "#0D6CF9";
  }, []);

  const goStoreUrl = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let storeUrl = "";

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      storeUrl = "https://apps.apple.com/kr/app/키즈다/id6738370393";
    } else {
      storeUrl =
        "https://play.google.com/store/apps/details?id=com.aslo.smartview.donga.kids";
    }

    return storeUrl;
  };

  return (
    <div className="app-landing-container">
      <ReactFullpage
        licenseKey={"PNYQI-8DWJK-9TRKK-F4J0J-JCGNL"}
        scrollingSpeed={500}
        navigation={true}
        onLeave={(origin, destination, direction) => {
          setSectionIndex(destination.index);
          setVisitedSections((prev) => new Set([...prev, destination.index]));
        }}
        render={({ state, fullpageApi }) => {
          fullpageApiRef.current = fullpageApi;

          return (
            <ReactFullpage.Wrapper>
              <div className="section" id="section1">
                <div className="section1-box box">
                  <ul className="slogan">
                    <li className="title desktop">
                      초등생 위한 교과 학습 뉴스 플랫폼
                    </li>
                    <li className="text">
                      <img src={section1Svg} alt="" />
                    </li>
                    <li className="title mobile">
                      초등생 위한 교과 학습 뉴스 플랫폼
                    </li>
                    <li className="download desktop">앱 스토어 다운로드</li>
                    <li className="btn-download desktop">
                      <div>
                        <a
                          href="https://apps.apple.com/kr/app/키즈다/id6738370393"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={appStoreSvg} alt="" />
                        </a>
                      </div>
                      <div>
                        <a href="https://play.google.com/store/apps/details?id=com.aslo.smartview.donga.kids">
                          <img src={playStoreSvg} alt="" />
                        </a>
                      </div>
                    </li>
                  </ul>
                  <div className="lottie">
                    {/* <img src={blueMonsterSvg} /> */}
                    <Lottie
                      animationData={yellowMonsterLottie}
                      // play={playedSections[0]}
                      // loop={false}
                      play
                      loop
                    />
                  </div>
                  <div className="btn-download mobile">
                    <button
                      onClick={() => {
                        window.open(goStoreUrl());
                      }}
                    >
                      <img src={appDownloadSvg} alt="" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="section" id="section2">
                <div className="section2-box box">
                  <ul className="slogan">
                    <li>
                      <img src={sectionTitle2Svg} alt="" />
                    </li>
                    <li>
                      <img src={sectionDescription2Svg} alt="" />
                    </li>
                  </ul>
                  <div
                    className={`svg animated-image ${
                      visitedSections.has(1) ? "show" : ""
                    }`}
                  >
                    <img src={greenMonsterSvg} alt="" />
                  </div>
                </div>
              </div>
              <div className="section" id="section3">
                <div className="section3-box box">
                  <ul className="slogan">
                    <li>
                      <img src={section3TitleSvg} alt="" />
                    </li>
                    <li>
                      <img src={sectionDescription3Svg} alt="" />
                    </li>
                  </ul>
                  <div
                    className={`svg animated-image ${
                      visitedSections.has(2) ? "show" : ""
                    }`}
                  >
                    <img src={researchSvg} alt="" />
                  </div>
                </div>
              </div>
              <div className="section" id="section4">
                <div className="section4-box box">
                  <ul className="slogan">
                    <li>
                      <img src={section4TitleSvg} alt="" />
                    </li>
                    <li>
                      <img src={sectionDescription4Svg} alt="" />
                    </li>
                  </ul>
                  <div
                    className={`svg animated-image ${
                      visitedSections.has(3) ? "show" : ""
                    }`}
                  >
                    <img src={familySvg} alt="" />
                  </div>
                </div>
              </div>
              <div className="section" id="section5">
                <div className="section5-box box">
                  <ul className="slogan">
                    <li>
                      <img src={section5TitleSvg} alt="" />
                    </li>
                    <li>
                      <img src={sectionDescription5Svg} alt="" />
                    </li>
                  </ul>
                  <div
                    className={`svg animated-image ${
                      visitedSections.has(4) ? "show" : ""
                    }`}
                  >
                    <img src={flowerStarSvg} alt="" />
                  </div>
                </div>
              </div>
              <div className="section" id="section6">
                <div className="section6-box box">
                  <ul className="slogan">
                    <li>
                      <img src={section6TitleSvg} alt="" />
                    </li>
                    <li>
                      <img src={sectionDescription6Svg} alt="" />
                    </li>
                  </ul>
                  <div
                    className={`svg animated-image ${
                      visitedSections.has(5) ? "show" : ""
                    }`}
                  >
                    <img src={studyLifeSvg} alt="" />
                  </div>
                </div>
              </div>
              <div className="section" id="section7">
                <div className="section7-box">
                  <ul className="info desktop">
                    <li>
                      <img src={logoBlack} alt="" />
                    </li>
                    <li>
                      상호&nbsp;|&nbsp;주식회사
                      위고컴퍼니&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <a
                        href="/application/service"
                        target="_blank"
                        rel="noreferrer"
                      >
                        이용약관
                      </a>
                      &nbsp;|&nbsp;
                      <a
                        href="/application/privacy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        개인정보처리방침
                      </a>
                    </li>
                    <li>
                      사업자등록번호&nbsp;|&nbsp;339-87-00990&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;대표자
                      성명&nbsp;:&nbsp;김영기
                    </li>
                    <li>
                      사업장 소재지(도로명주소)&nbsp;|&nbsp;경기도 화성시
                      동탄대로5길 21 4층 E420-A26호 (송동, 라크몽)
                    </li>
                    <li>
                      대표전화&nbsp;|&nbsp;02-3288-3455&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;청소년보호책임자&nbsp;|&nbsp;김준영
                    </li>
                    <li>통신판매업등록번호&nbsp;|&nbsp;2021-화성동탄-0946</li>
                    <li>제호&nbsp;|&nbsp;키즈다</li>
                  </ul>
                  <ul className="info mobile">
                    <li>
                      <img src={logoBlack} alt="" />
                    </li>
                    <li>
                      법인명&nbsp;|&nbsp;주식회사 위고컴퍼니
                      <br />
                      <a
                        href="/application/service"
                        target="_blank"
                        rel="noreferrer"
                      >
                        이용약관
                      </a>
                      &nbsp;|&nbsp;
                      <a
                        href="/application/privacy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        개인정보처리방침
                      </a>
                    </li>
                    <li>
                      사업장 소재지(도로명주소)&nbsp;|&nbsp;경기도 화성시
                      동탄대로5길 21 4층 E420-A26호 (송동, 라크몽)
                    </li>
                    <li>
                      사업자등록번호&nbsp;|&nbsp;339-87-00990
                      <br />
                      대표자 성명&nbsp;|&nbsp;김영기
                    </li>
                    <li>
                      대표전화&nbsp;|&nbsp;02-3288-3455
                      <br />
                      청소년보호책임자&nbsp;|&nbsp;김준영
                    </li>
                    <li>통신판매업등록번호&nbsp;|&nbsp;2021-화성동탄-0946</li>
                    <li>제호&nbsp;|&nbsp;키즈다</li>
                  </ul>
                  <div className="copyright">
                    Copyright by 키즈다 All rights reserved.
                  </div>
                </div>
              </div>
            </ReactFullpage.Wrapper>
          );
        }}
      />
      <div className="header">
        <div className="header-box">
          <div className="logo">
            <a
              onClick={() => {
                fullpageApiRef.current.moveTo(1);
              }}
            >
              {/* <img src={logoWhiteSvg} alt="" /> */}
              <img src={logoWhite} alt="" />
            </a>
          </div>
          <div className="menu-box">
            <div className="menu">
              <div>
                <a href="/">키즈다 소개</a>
              </div>
              <div>
                <a href="/product">구독</a>
              </div>
              <div>
                <a href="/educlip">에듀클립</a>
              </div>
            </div>
            <div
              className="app-download"
              style={{ display: sectionIndex === 0 ? "none" : "" }}
            >
              <button
                onClick={() => {
                  window.open(goStoreUrl());
                }}
              >
                앱 다운로드
              </button>
            </div>
          </div>
          <div
            className="hamburger"
            style={{ display: sectionIndex === 0 ? "" : "none" }}
          >
            <img
              src={buttonHamburgerWhiteSvg}
              alt=""
              onClick={() => setIsOpen(!isOpen)}
            />
          </div>
          <div className={`mobile-slide-menu ${isOpen ? "open" : ""}`}>
            <div className="close-button" onClick={() => setIsOpen(false)}>
              &times;
            </div>
            <div className="on">
              <a href="/">키즈다 소개</a>
            </div>
            <div>
              <a href="/product">구독</a>
            </div>
            <div>
              <a href="/educlip">에듀클립</a>
            </div>
          </div>
        </div>
      </div>
      <img
        src={scrollDownSvg}
        className={`scroll desktop ${
          sectionIndex === 6 ? `hidden-important` : ""
        }`}
        style={{ display: sectionIndex === 6 ? "none" : "" }}
        onClick={() => onNextPage()}
        alt=""
      />
      <img
        src={scrollDownMobileSvg}
        className={`scroll mobile ${
          sectionIndex === 6 ? `hidden-important` : ""
        }`}
        onClick={() => onNextPage()}
        alt=""
      />

      <SvgPopup
        svgUrl={serverMaintenance}
        storageKey="server_maintenance_popup"
      />
    </div>
  );
}

export default AppLanding;
